import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@amplify/amplify-icon-button';
import ScoreInterpretationMapper from '../../../constants/shared/ScoreInterpretationMapper';
import { CELL_TYPE } from '../../../constants/shared/CellConstants';
import './CompositeCell.scss';

const CompositeCell = props => {
    if (CELL_TYPE.BENCHMARK === props.cellType) {
        return <BenchmarkCompositeCell {...props} />;
    }
    return <StudentSummaryCompositeCell {...props} />;
};

CompositeCell.defaultProps = {
    cellType: null,
};

CompositeCell.propTypes = {
    cellType: PropTypes.string,
};

export const BenchmarkCompositeCell = ({
    interp,
    score,
    optionalCellData,
    percentile,
    isSecure,
    resetCellData,
}) => {
    return (
        <div className="bm-comp-container-with-reset-button">
            <div
                className={`data-cell bm-comp-container composite ${interp} ${
                    optionalCellData.percentileClassName
                } background-white ${optionalCellData.classNames} ${
                    isSecure && score && 'e-composite-cell'
                } ${resetCellData.isResetButtonAvailableInClass && 'no-right-border'}`}
            >
                {isSecure && score && (
                    <div className="e-composite-icon">
                        <b>E</b>
                    </div>
                )}
                <div className={`score ${optionalCellData.percentileClassName}`}>{score}</div>
                {ScoreInterpretationMapper[interp]}
                {optionalCellData.isPercentileShown && percentile && (
                    <div className="score-interp">Pctl: {percentile}</div>
                )}
            </div>

            {resetCellData.isResetButtonAvailableInClass && (
                <div className="reset-button">
                    {resetCellData.isResetButtonAvailable && (
                        <IconButton
                            icon="icon-v2-reset"
                            onClick={() => {
                                resetCellData.showSecondAttemptBulkInvalidationModal(
                                    optionalCellData.studentInfo,
                                );
                            }}
                            variant="label"
                        >
                            Reset
                        </IconButton>
                    )}
                </div>
            )}
        </div>
    );
};

BenchmarkCompositeCell.defaultProps = {
    interp: null,
    score: null,
    optionalCellData: {},
    percentile: null,
    isSecure: false,
    resetCellData: {
        isResetButtonAvailable: false,
        isResetButtonAvailableInClass: false,
        showSecondAttemptBulkInvalidationModal: () => {},
    },
};

BenchmarkCompositeCell.propTypes = {
    interp: PropTypes.string,
    score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    optionalCellData: PropTypes.object,
    percentile: PropTypes.number,
    isSecure: PropTypes.bool,
    resetCellData: PropTypes.object,
};

const StudentSummaryCompositeCell = props => {
    const { optionalCellData, interp, score, goalSection, isSecure } = props;
    return (
        <div
            className={`data-cell ss ${score ? '' : 'empty-score'} ${
                optionalCellData.classNames
            } composite ${interp} background-white ${isSecure && score && 'e-composite-cell'}`}
        >
            <div className={`ss-comp-container ${optionalCellData.goal ? '' : 'empty-goal'}`}>
                <div className="ss-comp-goal">{goalSection}</div>
                {isSecure && score && (
                    <div className="e-composite-icon">
                        <b>E</b>
                    </div>
                )}
                <div className="score">{score}</div>
                <div className="ss-interp">{ScoreInterpretationMapper[interp]}</div>
                <div className="ss-bottom" />
            </div>
        </div>
    );
};

StudentSummaryCompositeCell.defaultProps = {
    interp: null,
    score: null,
    optionalCellData: {},
    goalSection: '',
    isSecure: false,
};

StudentSummaryCompositeCell.propTypes = {
    interp: PropTypes.string,
    score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    optionalCellData: PropTypes.object,
    goalSection: PropTypes.string,
    isSecure: PropTypes.bool,
};

export default CompositeCell;
